import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=5be81a16"
import script from "./MenuItems.vue?vue&type=script&lang=ts"
export * from "./MenuItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports